// Centraliserad blogg-data. Lägg till nya artiklar genom att utöka POSTS-arrayen.
// Varje post består av: slug, title, excerpt, hero (emoji eller img-url), date (ISO), readMinutes, category, content (JSX-array).

const POSTS = [
  {
    slug: 'basta-bygg-kalkyl-program-2026',
    title: 'Bästa bygg kalkyl­program 2026 — vi jämför 6 verktyg',
    excerpt: 'Letar du efter rätt bygg kalkyl­program för 2026? Vi har jämfört de 6 mest populära verktygen på svenska marknaden — funktioner, AI-stöd, priser och vem de passar för.',
    keywords: 'bästa bygg kalkyl program 2026, jämförelse bygg kalkyl, vinst bygg AI, offertverktyg jämförelse',
    date: '2026-01-15',
    readMinutes: 8,
    category: 'Verktygsguide',
  },
  {
    slug: 'digitalisering-byggbranschen-guide',
    title: 'Digitalisering i byggbranschen 2026 — komplett guide',
    excerpt: 'Från Excel till AI: så går du från analog till digital byggadministration på 90 dagar. Konkret plan, checklista och fallgropar att undvika.',
    keywords: 'digitalisering byggbranschen, bygg digital transformation, AI bygg sverige',
    date: '2026-01-22',
    readMinutes: 11,
    category: 'Strategi',
  },
];

export const getAllPosts = () => POSTS.slice().sort((a, b) => b.date.localeCompare(a.date));
export const getPostBySlug = (slug) => POSTS.find((p) => p.slug === slug);

export default POSTS;
